import ProgressCircle from '../../elements/progress-circle';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var LoadingState = function LoadingState(_ref) {
  var label = _ref.label;
  return _jsx("div", {
    sx: {
      display: 'flex',
      justifyContent: 'center'
    },
    children: _jsxs("div", {
      sx: {
        textAlign: 'center',
        paddingTop: 'lg',
        paddingBottom: 'xxl',
        paddingX: 'xxl',
        backgroundColor: 'grey-0'
      },
      children: [_jsx("h3", {
        sx: {
          paddingBottom: 'xxl'
        },
        children: label
      }), _jsx(ProgressCircle, {})]
    })
  });
};

export default LoadingState;
//# sourceMappingURL=index.js.map